const drawerAccountSelectors = {
  AccountIconDesktop: document.querySelector('#account-drawer')
};

class accountDrawer extends HTMLElement {
  constructor() {
    super();
    this.openeBy = drawerAccountSelectors.AccountIconDesktop;
    this.bindEvents();
    this.querySelectorAll('.close-account--drawer').forEach(button => button.addEventListener('click', this.closeAccountDrawer.bind(this)));
  }

  onKeyUp(event) {
    if (event.code != undefined) {
      if(event.code.toUpperCase() !== 'ESCAPE') return; 
    }
    // this.querySelector('.close-account--drawer').dispatchEvent(new Event('click'));
  }

  bindEvents() {
    this.openeBy.addEventListener('click', this.openAccountDrawer.bind(this));
    this.addEventListener('keyup', this.onKeyUp.bind(this));
  }

  openAccountDrawer(event) {
    event.stopPropagation();
    this.classList.add('opened-drawer');
    if (window.screen.width > 1199) {
      siteOverlay.prototype.showOverlay();
    }
    Utility.forceFocus(this.querySelector('.account-drawer-title'));
    let closeBtn = this.querySelector('.close-account--drawer');
    Utility.trapFocus(this, closeBtn);
  
    if(event){
      event.preventDefault();
      let openBy = event.currentTarget;
      openBy.setAttribute('aria-expanded', true);
    }
  }

  closeAccountDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      event.preventDefault();
      this.classList.remove('opened-drawer');
      if (window.screen.width > 1199) {
        siteOverlay.prototype.hideOverlay();
      }
      let openByEle = event.currentTarget;
      openByEle.setAttribute('aria-expanded', false);
      Utility.removeTrapFocus(elementToFocus);

      let actionBtn = drawerAccountSelectors.AccountIconDesktop;
      if(window.innerWidth < 1024){
        actionBtn = drawerAccountSelectors.AccountIconDesktop;
      }
      Utility.forceFocus(actionBtn);
    }
  }

}
customElements.define("account-drawer", accountDrawer);